import Twig from 'twig';

let CorpResp = {
    Charity: {
        initSelectizeEvents: function(select){
            select.selectize({
                onChange: function(value){
                    var elem = this.$input[0],
                        container = $(elem).closest('[data-select-events-charity-corp-resp-wrap]');

                    // fix бага selectize с выбранным элементом
                    container.find('.option').removeClass('selected');
                    container.find('[data-value="'+value+'"].option').addClass('selected');
                    
                    container.find('[data-tab-pane]').removeClass('active');
                    $('[data-tab-pane="' + value + '"]').addClass('active');

                    CorpResp.Charity.getAjaxDataEvents(value);
                }
            });
        },
        initSliderEvents: function(slider){
            slider.slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 1000,
                fade: true,
                arrows: true,
                dots: false,
                infinite: true,
                prevArrow : '<div class="slick-prev"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
                nextArrow : '<div class="slick-next"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: false,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            })
            .on('beforeChange', function(event, slick){});
        },
        getAjaxDataEvents: function(idEvent){
            $.ajax({
              url: '/local/ajax/events-charity-corp-resp.json?event='+idEvent,
              dataType: 'json',
              beforeSend: function(){
                $('[data-slider-corp-resp-charity-container]').find('[data-loader]').show();
              },
              success: function(_data){

                if(_data.items.length > 0){
                    var sliderEvents = $('[data-slider-corp-resp-charity]'),
                        container = sliderEvents.closest('[data-slider-corp-resp-charity-container]');
                    
                    var template = Twig.twig({
                        data:   '<div class="slide__wrap">'+
                                    '<div class="slide-img" style="background-image: url(\'{{ data.img }}\')"></div>'+
                                    '<div class="slide">'+
                                        '<div class="slide__title">{{ data.title|raw }}</div>'+
                                        '{% if data.subtitle|length %}'+
                                            '<div class="slide__subtitle">{{ data.subtitle|raw }}</div>'+
                                        '{% endif %}'+
                                    '</div>'+
                                '</div>'
                    });
                  
                    sliderEvents.slick('destroy');
                    sliderEvents.html('');

                    _data.items.forEach(function(item, i){
                        sliderEvents.append(template.render({
                          data: {
                                title: item.title,
                                subtitle: item.subtitle,
                                img: item.img
                            }
                        }));
                    });

                    CorpResp.Charity.initSliderEvents(sliderEvents);

                    container.find('[data-loader]').hide();
                }
              }
            });
        }
        
    },
    Ecology: {
        initSlider: function(slider){
            slider.slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 1000,
                fade: true,
                arrows: true,
                dots: false,
                infinite: true,
                prevArrow : '<div class="slick-prev"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
                nextArrow : '<div class="slick-next"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: true,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            })
            .on('beforeChange', function(event, slick){});
        }
    }
}

$(document).ready(function ($) {
    let sliderEvents = $('[data-slider-corp-resp-charity]');
    if(sliderEvents.length){
        CorpResp.Charity.initSliderEvents(sliderEvents);
    }

    let selectEvents = $('[data-select-events-charity-corp-resp]');
    if(selectEvents.length){
        CorpResp.Charity.initSelectizeEvents(selectEvents);
    }

    let sliderEcology = $('[data-slider-corp-resp-ecology]');
    if(sliderEcology.length){
        CorpResp.Ecology.initSlider(sliderEcology);
    }
    
});



// WEBPACK FOOTER //
// ./components/corporate-responsibility.js